import { tv } from "../../variants/tv.js";
const acquisitionFormVariants = tv({
    slots: {
        root: 'flex w-full flex-col gap-4',
        layoutWrapper: 'flex w-full flex-col gap-5 @lg:flex-row @lg:items-center',
        layoutColumn: '@container flex w-full min-w-0 flex-1 flex-col gap-4',
        childrenSlot: 'w-full',
        formContainer: 'flex flex-col gap-4',
        fieldsRow: 'flex flex-col gap-3',
        nameFieldsRow: 'flex flex-col gap-3 @md:flex-row',
        inputWrapper: 'w-full @md:min-w-0 @md:flex-1',
        buttonWrapper: 'w-full flex-shrink-0 @md:self-end',
        termsWrapper: 'flex items-start gap-2',
        disclaimerSlot: 'text-body3 text-pretty whitespace-pre-line text-neutral-11',
        qrCodeWrapper: 'hidden shrink-0 flex-col items-center gap-1 overflow-hidden rounded-lg bg-primary-3 p-2 lg:flex',
        qrCodeImage: 'size-36 shrink-0',
        qrCodeText: 'w-full text-center text-body3 text-neutral-11',
        bannerWrapper: 'w-full'
    },
    variants: {
        emphasis: {
            regular: {
                disclaimerSlot: 'text-neutral-11',
                qrCodeText: 'text-neutral-11'
            },
            medium: {
                disclaimerSlot: 'text-neutral-12',
                qrCodeText: 'text-neutral-12'
            },
            bold: {
                disclaimerSlot: 'text-primary-1',
                qrCodeText: 'text-primary-1'
            }
        },
        layout: {
            stacked: {
                fieldsRow: 'flex-col',
                buttonWrapper: 'w-full'
            },
            inline: {
                fieldsRow: '@md:flex-row @md:items-end',
                buttonWrapper: '@md:w-auto'
            }
        },
        appDownloadColumn: {
            true: {
                fieldsRow: '@xs:flex-row @xs:items-end',
                inputWrapper: '@xs:min-w-0 @xs:flex-1',
                buttonWrapper: '@xs:w-auto @xs:self-end'
            }
        }
    },
    defaultVariants: {
        emphasis: 'regular',
        layout: 'inline',
        appDownloadColumn: false
    }
});
export { acquisitionFormVariants };
